/* eslint-disable max-len */
import React from 'react'
import { useAppTranslation } from '../../../../../hooks/useAppTranslation'
import { ErrorBoundary } from '../../../../../components/common/ErrorBoundary'
import { ViewBase } from '../../../../../components/common/ViewBase'
import { ManagementPartner } from '../../../../../components/society/ManagementPartner/management_partner'
import { ManagementPartnerBase } from '../../../../../components/society/ManagementPartner/ManagementPartnerBase'
import { ManagementPartnerCard } from '../../../../../components/society/ManagementPartner/ManagementPartnerCard'
import { BOSTADSRATTERNA_FORMS_LINK } from '../../../../../constants/Links'
import { useCurrentSociety } from '../../../../../hooks/useCurrentSociety'
import { useDocumentTitle } from '../../../../../hooks/useDocumentTitle'
import { reverseDocumentTitle } from '../../../../../navigation/reverseDocumentTitle'
import { i18nSocietyType } from '../../../../../i18n'

export const BostadsratternaFormsView = (): React.ReactNode => {
  const { translate } = useAppTranslation()
  const { society } = useCurrentSociety()
  useDocumentTitle(
    reverseDocumentTitle('management:bostadsratterna-forms', {
      '{{ societyName }}': society?.name,
    })
  )

  return (
    <ErrorBoundary>
      <ViewBase
        title={translate('bostadsratterna.bostadsratternaFormsView.title')}
      >
        <ManagementPartnerBase partner={ManagementPartner.BOSTADSRATTERNA}>
          <ManagementPartnerCard
            url={BOSTADSRATTERNA_FORMS_LINK}
            title={translate(
              'bostadsratterna.bostadsratternaFormsView.formsTitle'
            )}
            text={translate(
              'bostadsratterna.bostadsratternaFormsView.formsText',
              { context: i18nSocietyType(society?.societyTypeDisplayName) }
            )}
          />
        </ManagementPartnerBase>
      </ViewBase>
    </ErrorBoundary>
  )
}
